export const colors = {
  lime: {
    darker: "#94E616",
    default: "#C8E22E",
    lighter: "#E0F8A4",
  },
  purple: {
    darker: "#B44DF5",
    default: "#D68CFA",
    lighter: "#EBC5FD",
    lightest: "#F0DAFF",
  },
  tan: {
    darker: "#D9D7BA",
    default: "#EBEADA",
    lighter: "#F7F7F0",
  },

  black: "#000000",

  grey: {
    shade1: "#9A9A9A",
    shade2: "#D1D1D1",
    shade3: "#D5D7DA",
    shade4: "#E3E9ED",
  },

  white: "#FFFFFF",

  pink: {
    darker: "#C7325D",
    default: "#F23D6F",
    lighter: "#F781A1",
    lightest: "#FCD1DE",
  },

  navy: {
    darker: "#040630",
    default: "#0D0A3B",
    lighter: "#6A619B",
    lightest: "#A9A4C6",
  },

  burgundy: {
    darker: "#2F0818",
    default: "#490B24",
    lighter: "#6D3C50",
    lightest: "#A38491",
  },
  olive: {
    darker: "#88983E",
    default: "#BAC57E",
    lighter: "#CFD7A5",
    lightest: "#E3E8CB",
  },
  forest: {
    darker: "#182D17",
    default: "#254023",
    lighter: "#51664F",
    lightest: "#7C8C7B",
  },
  blue: {
    darker: "#095BDE",
    default: "#2F98EE",
    lighter: "#6EB7F4",
    lightest: "#ACD6F8",
  },
  yellow: {
    darker: "#E68609",
    default: "#F2B931",
    lighter: "#F6CE6F",
    lightest: "#FAE3AD",
  },
  red: {
    darker: "#CB0100",
    default: "#F14325",
    lighter: "#F67C67",
    lightest: "#F9B4A8",
  },
} as const;

const scales = (function generateScales() {
  const result: string[][] = [
    [colors.black, colors.grey.shade1, colors.grey.shade2, colors.grey.shade3, colors.grey.shade4, colors.white],
  ];
  for (const colorName of Object.keys(colors)) {
    const colorValues = colors[colorName as keyof typeof colors];
    if (typeof colorValues === "object" && Object.hasOwn(colorValues, "default")) {
      const scale: string[] = [];
      if ("darkest" in colorValues) scale.push(colorValues.darkest as string);
      if ("darker" in colorValues) scale.push(colorValues.darker as string);
      if ("default" in colorValues) scale.push(colorValues.default as string);
      if ("lighter" in colorValues) scale.push(colorValues.lighter as string);
      if ("lightest" in colorValues) scale.push(colorValues.lightest as string);
      result.push(scale);
    }
  }
  return result;
})();

export const darker = (color: string) => {
  for (const scale of scales) {
    const i = scale.indexOf(color);
    if (i === -1) continue;
    if (i === 0) return colors.black;
    return scale[i - 1];
  }
  return color;
};

export const lighter = (color: string) => {
  for (const scale of scales) {
    const i = scale.indexOf(color);
    if (i === -1) continue;
    if (i === scale.length - 1) return colors.white;
    return scale[i + 1];
  }
  return color;
};
